import "./assets/js/nav-pills.js";
import "./assets/scss/argon-dashboard.scss";
import "./assets/scss/custom.scss";

export default {
  install() {},
};
